import React, { useState, useEffect } from "react";
import "./styles.css";


export default function RoughCountryBanner() {

    const [showGuaranteeModal, setShowGuaranteeModal] = useState(false);
    const [showFitModal, setShowFitModal] = useState(false);
    const [showShippingModal, setShowShippingModal] = useState(false);

    useEffect(() => {
        if (showGuaranteeModal || showFitModal || showShippingModal) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
        return () => {
            document.body.style.overflow = "auto";
        };
    }, [showGuaranteeModal, showFitModal, showShippingModal]);


    return (
        <section className="fitment-section py-5">

            <div className="top-benefits-banner">
                <div className="benefits-wrapper">

                    <div className="benefit-item">
                        <div className="icon-box">
                            <i className="fa fa-refresh"></i>
                        </div>
                        <div>
                            <h1>90 DAY RETURNS</h1>
                            <p
                                className="clickable-text"
                                onClick={() => setShowGuaranteeModal(true)}
                            >
                                SATISFACTION GUARANTEE
                            </p>
                        </div>
                    </div>

                    <div className="benefit-item">
                        <div className="icon-box">
                            <i className="fa fa-wrench"></i>
                        </div>
                        <div>
                            <h1>FIT GUARANTEED</h1>
                            <p
                                className="clickable-text"
                                onClick={() => setShowFitModal(true)}
                            >
                                READY FOR INSTALL
                            </p>
                        </div>
                    </div>

                    <div className="benefit-item">
                        <div className="icon-box">
                            <i className="fa fa-truck"></i>
                        </div>
                        <div>
                            <h1>FREE SHIPPING</h1>
                            <p
                                className="clickable-text"
                                onClick={() => setShowShippingModal(true)}
                            >
                                1-3 DAY DELIVERY*
                            </p>
                        </div>
                    </div>

                </div>
            </div>

            {showGuaranteeModal && (
                <div className="custom-modal-overlay">
                    <div className="custom-modal">

                        <button
                            className="modal-close"
                            onClick={() => setShowGuaranteeModal(false)}
                        >
                            ✕
                        </button>

                        <div className="modal-header-section">
                            <div className="modal-icon">
                                <i className="fa fa-calendar-check-o"></i>
                            </div>

                            <div>
                                <span className="modal-subtitle">
                                    We've Got Your Back
                                </span>
                                <h2>90 DAY RETURNS</h2>
                            </div>
                        </div>

                        <h6>
                            Purchase ANY Rough Country product and if you aren't 100% satisfied with every aspect of your purchase, you can return it for a REFUND of the retail price within 90 DAYS with no questions asked!
                        </h6>

                        <h6>Offer</h6>
                        <p>
                            We're confident in the high quality of our products. We invite you to install a Rough Country product on your vehicle. Use it! Bolt it on; take it out for a spin. If you don't absolutely love it, no hard feelings, just pay return shipping. We'll credit your original purchase price.
                        </p>

                        <h6>Terms</h6>
                        <p>
                            All items are eligible for return under this policy. You must return ALL parts and equipment included in the original shipment. Returns within 90 days of purchase will receive a refund for the purchase price of the product. Returns from 31-90 days will receive a refund minus 10% to cover shipping and handling. Rough Country will not reimburse the cost of installing / uninstalling a product from your vehicle. Items purchased from Rough Country Dealers or stores must be returned to those stores in conjunction with that store's policy.
                        </p>

                        <a href="/terms-conditoins" className="return-policy-link">
                            READ OUR RETURN POLICY
                        </a>
                    </div>
                </div>
            )}

            {showFitModal && (
                <div className="custom-modal-overlay">
                    <div className="custom-modal">

                        <button
                            className="modal-close"
                            onClick={() => setShowFitModal(false)}
                        >
                            ✕
                        </button>

                        <div className="modal-header-section">
                            <div className="modal-icon">
                                <i className="fa fa-wrench"></i>
                            </div>

                            <div>
                                <span className="modal-subtitle">
                                    We’ve Got Your Back
                                </span>
                                <h2>FIT GUARANTEED</h2>
                            </div>
                        </div>

                        <h6>You Choose the Gear. We Guarantee the Fit.</h6>

                        <p style={{ marginTop: "10px" }}>
                            With Rough Country’s Fitment Guarantee, we take the guesswork out of your next upgrade. When you see the green “FITS YOUR VEHICLE” checkmark, that’s our promise—it means we’ve verified the product to match your exact make and model. If we say it fits, it does. And if it doesn’t, we’ll make it right. No guesswork. No surprises. Just the right gear, ready for install. Every item with this badge is backed by real-world compatibility and our commitment to getting it right the first time. If you're ever unsure, our experienced sales team is just a call away, ready to walk you through fitment and get you squared away with the right gear.
                        </p>
                    </div>
                </div>
            )}

            {showShippingModal && (
                <div className="custom-modal-overlay">
                    <div className="custom-modal">

                        <button
                            className="modal-close"
                            onClick={() => setShowShippingModal(false)}
                        >
                            ✕
                        </button>

                        <div className="modal-header-section">
                            <div className="modal-icon">
                                <i className="fa fa-truck"></i>
                            </div>

                            <div>
                                <span className="modal-subtitle">
                                    We’ve Got Your Back
                                </span>
                                <h2>FREE SHIPPING</h2>
                            </div>
                        </div>

                        <h6>
                            If you place your order before 4:00pm (CST), Monday-Friday, your order will be shipped that day. Parts ordered must be in stock for the order to ship.
                        </h6>

                        <h6>Free</h6>
                        <p>
                            Qualifying orders for Free Shipping are shipped via ground delivery. Free Shipping is only applicable to the contiguous United States. Excludes Alaska, Hawaii, and Canada. Please check the product page to see if it qualifies for Free Shipping. Select products over a certain size or weight may require freight shipping. Freight shipping to commercial addresses with a loading dock are free. Freight shipping to residential addresses will require an additional delivery charge.
                        </p>

                        <h6>Fast</h6>
                        <p>
                            Approximately 98% of all orders placed leave our warehouses the same day (not including weekends & holidays). Once an order has shipped, average Ground transit time is an additional 1 to 3 working days.
                        </p>

                        <a href="/terms-conditoins" className="return-policy-link">
                            READ OUR SHIPPING POLICY
                        </a>

                    </div>
                </div>
            )}
        </section>
    );
}
